import { ChangeDetectorRef, NgModule, ViewContainerRef } from '@angular/core';
import { Component, OnInit, OnDestroy, ViewChild, ElementRef, Renderer2 } from '@angular/core';
import { TamasAlunoService } from '../tamas-aluno.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { FormControl } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import { AlertaSimplesDialog } from '../alerta-simples';
import { AlertaInputDialog } from '../alerta-input';
import { AlertaConfirmDialog } from '../alerta-confirm';
import { Location } from '@angular/common';
import { AlertaTermosDialog } from '../alerta-termos';
import { isNgTemplate } from '../../../node_modules/@angular/compiler';
// import html2canvas from 'html2canvas';
declare function RenderizarEvolucaoPeso(peso, massamagra, massagorda, periodo): any;

@Component({
  selector: 'app-dashboard-comparacao',
  templateUrl: './dashboard-comparacao.component.html',
  styleUrls: ['./dashboard-comparacao.component.css']
})

export class DashboardComparacaoComponent implements OnInit {
  //displayedColumns = ['position', 'name', 'weight', 'symbol'];
  displayedColumns = ['Avaliação', 'Ombro', 'Tórax', 'Abdomem', 'Quadril', 'Braço D Rl', 'Braço D Ct', 'Braço E Rl', 'Braço E Ct', 'Antebraço D', 'Antebraço E', 'Coxa D', 'Coxa E', 'Panturrilha D', 'Panturrilha E'];
  dataSource = ELEMENT_DATA;
  displayedColumns2 = [{ key: 'Parte', header: 'Parte' }];
  displayedColumns3 = [{ key: 'Parte', header: 'Parte' }];
  displayedColumnsKeys: string[];
  displayedColumnsKeys3: string[];
  hideLoginLoad: boolean = false;
  idPaciente: any = 0;
  idPlano: any = 0;
  tipoPlano: any = '';
  periodoC: boolean = true;
  dataFiltrar: any = '';
  view: any[] = [992, 300];
  // options for the chart
  showXAxis = true;
  showYAxis = true;
  gradient = true;
  showLegend = false;
  legendTitle: any = '';
  // options
  legend: boolean = true;
  showLabels: boolean = true;
  animations: boolean = true;
  xAxis: boolean = true;
  yAxis: boolean = true;
  showYAxisLabel: boolean = true;
  showXAxisLabel: boolean = true;
  xAxisLabel: string = 'Composição';
  xAxisLabel2: string = 'Avaliações';
  yAxisLabel: string = 'Valor em Kg';
  yAxisLabel3: string = 'Valor em MM';
  timeline: boolean = true;
  dataplano: any = '';
  datahj: any = '';
  contadorDP: any = 0;

  colorSchemeDobras = {
    domain: ['#2597fb', '#65ebfd', '#99fdd0', '#3f51b5', '#647c8a', '#a8385d', '#aae3f5']
  }


  colorSchemePeso = {
    domain: ['#58dc65', '#de5353', '#eee244']
  };
  colorScheme = {
    domain: ['#DE5353', '#3400F2', '#999999', '#00F2E2', '#F27D00', '#EE4488', '#EEE244', '#04670E', '#58DC65']
  };
  colorSchemeMassa = {
    domain: ['#2597fb', '#65ebfd', '#99fdd0', '#3f51b5', '#647c8a', '#a8385d', '#aae3f5']
  }


  public single = [];
  public multi = [];
  public multi2 = [];
  public multiDobras = [];
  public grAdereDia = [];
  public aproveitamento = [];
  arrAvaliacoes: any[] = [];
  arrAvSelec: any[] = [];
  arrComp: any[] = [];
  arrAv: any[] = [];
  startView: string = "multi-year"
  arrCirc: any[] = [];
  arrDobras: any[] = [];
  tabelaCircu: any[] = [];
  tabelaDobras: any[] = [];
  comparou: boolean = false;

  @ViewChild('chart') chart: ElementRef;
  first: boolean = true;
  dataEvPeso: any[] = [];
  dataEvMassaM: any[] = [];
  dataEvMassaG: any[] = [];
  dataEvPeriodo: any[] = [];

  constructor(public viewContainerRef: ViewContainerRef, private cdRef: ChangeDetectorRef, private route: ActivatedRoute, public tmaService: TamasAlunoService, public router: Router, public dialog: MatDialog, private _location: Location) { }

  ngOnInit() {
    this.tmaService.eventoFS(true);
    this.hideLoginLoad = false;
    this.idPaciente = this.route.snapshot.paramMap.get('idpaciente');
    //this.loadScript('../../assets/js/grafico-apx.js');
    // this.tipoPlano = this.route.snapshot.paramMap.get('tipoplano');
    // this.idPlano = this.route.snapshot.paramMap.get('idplano');
    this.carregarAvaliacoes();
  }

  ngOnDestroy() {
    console.log("destroy");
    this.tmaService.eventoFS(false);
  }

  public loadScript(url: string) {
    const body = <HTMLDivElement>document.body;
    const script = document.createElement('script');
    script.innerHTML = '';
    script.type = 'text/javascript';
    script.src = url;
    script.async = false;
    script.defer = true;
    body.appendChild(script);
  }


  carregarAvaliacoes(): void {
    var dadosF = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idpaciente=' + this.idPaciente;
    this.tmaService.getAvaliacoes(dadosF).subscribe((qRes) => {
      this.hideLoginLoad = true;
      console.log(qRes);
      if (qRes['res'] == 'ok') {
        this.arrAvaliacoes = qRes['listaAV'];
      }
      else {

      }
    })
  }

  compararAval(): void {
    //tratar o array
    this.arrAvSelec = [];
    this.arrAvaliacoes.forEach(item => {
      if (item.check) {
        this.arrAvSelec.push(item);
      }
    });

    if (this.arrAvSelec.length < 2) {
      const avisoSele = this.dialog.open(AlertaSimplesDialog, {
        // width: '250px',
        disableClose: true,
        data: { textoAlerta: "Você deve escolher pelo menos 2 avaliações para gerar um relatório" }
      });

    }
    else {
      //this.viewContainerRef.clear();



      this.tabelaCircu = [];
      this.tabelaDobras = [];
      this.displayedColumnsKeys = [];
      this.displayedColumnsKeys3 = [];
      this.dataEvMassaG = [];
      this.dataEvMassaM = [];
      this.dataEvPeso = [];
      this.dataEvPeriodo = [];
      this.chart.nativeElement.innerHTML= '';
      //como podemos renderizar a mesma tabela várias vezes, 
      //fazemos o reset abaixo para que não dê erro de colunas duplicadas
      if (!this.first) {
        this.displayedColumns = [];
        this.displayedColumns3 = [];
        this.displayedColumns2 = [{ key: 'Parte', header: 'Parte' }];
        this.displayedColumns3 = [{ key: 'Parte', header: 'Parte' }];
      }


      var meuArray = JSON.stringify(this.arrAvSelec);

      let customParams = {
        //lista: localStorage.getItem('turboCart'),
        email: this.tmaService.hcEmail,
        senha: this.tmaService.hcSenha,
        strpaciente: this.idPaciente,
        listaAvaliacoes: meuArray
      };


      this.hideLoginLoad = false;
      this.tmaService.compareAv(customParams)
        .subscribe((qDados) => {
          console.log(qDados);
          this.hideLoginLoad = true;
          if (qDados['res'] == 'ok') {
            this.comparou = true;
            this.arrComp = qDados['dadosComp'];
            //this.arrCirc = qDados['dadosCirc'];
            //this.arrDobras = qDados['dadosDobras'];
            this.tabelaCircu = qDados['dadosCircunferencias2'];
            this.tabelaDobras = qDados['dadosDobras2'];
            this.cdRef.detectChanges();
            this.renderGrafic();
            this.first = false;
          }
          else {
            //erro
          }
        })
    }

  }

  renderGrafic(): void {
    console.log("renderizar");
    var avComp = [];
    var av_massaAV = [];
    var av_massaC = [];
    var av_massaG = [];
    var av_massaGp = [];
    var av_massaM = [];
    var av_massaMp = [];

    var db_Subescapular = [];
    var db_Triceps = [];
    var db_Peitoral = [];
    var db_Biceps = [];
    var db_AxilarMedia = [];
    var db_Suprailiaca = [];
    var db_Adbominal = [];
    var db_CoxaMedial = [];
    var db_Perna = [];



    this.arrDobras.forEach((item, idx) => {
      var nomeAv = "(" + (idx + 1) + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo + "-" + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).data;
      //var nomeAv =  "(" + (idx + 1) + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo;
      db_Subescapular.push({ name: nomeAv, value: item.DbSubescapular });
      db_Triceps.push({ name: nomeAv, value: item.DbTriceps });
      db_Peitoral.push({ name: nomeAv, value: item.DbPeitoral });
      db_Biceps.push({ name: nomeAv, value: item.DbBiceps });
      db_AxilarMedia.push({ name: nomeAv, value: item.DbAxilarMedia });
      db_Suprailiaca.push({ name: nomeAv, value: item.DbSuprailiaca });
      db_Adbominal.push({ name: nomeAv, value: item.DbAdbominal });
      db_CoxaMedial.push({ name: nomeAv, value: item.DbCoxaMedial });
      db_Perna.push({ name: nomeAv, value: item.DbPerna });
    });


    var arrTdobras = [];
    this.arrComp.forEach((item, idx) => {
      // avComp.push({name: item.dia, value: item.qtdDone });
      //var nomeAv = this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo + " (" + item.IdAvaliacao + ")";
      //var nomeAv = "(" + item.IdAvaliacao + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).data;
      //var nomeAv = "(" + item.IdAvaliacao + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo;
      //var nomeAv = "(" + (idx + 1) + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo;

      var nomeAv = "(" + (idx + 1) + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo + "-" + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).data;
      av_massaC.push({ name: nomeAv, value: item.MassaCorporal });
      av_massaG.push({ name: nomeAv, value: item.MassaGorduraKg });
      av_massaGp.push({ name: nomeAv, value: item.MassaGorduraPercentual });
      av_massaM.push({ name: nomeAv, value: item.MassaLivreGorduraKg });
      av_massaMp.push({ name: nomeAv, value: item.MassaLivreGorduraPercentual });

      var numQ = idx + 1;
      this.displayedColumns2.push({ key: 'Resultado' + numQ, header: nomeAv });
      this.displayedColumns3.push({ key: 'Resultado' + numQ, header: nomeAv });
      //arrTdobras.push({ Parte: 'Adbominal', nomeAv: 21});

      //agrupar por item da composição - peso, massa magra e gordura
      av_massaAV.push({ name: nomeAv, series: [{ name: 'Peso', value: item.MassaCorporal }, { name: 'Massa Magra', value: item.MassaLivreGorduraKg }, { name: 'Gordura', value: item.MassaGorduraKg }] });


      this.dataEvPeso.push(item.MassaCorporal);
      this.dataEvMassaM.push(item.MassaLivreGorduraKg);
      this.dataEvMassaG.push(item.MassaGorduraKg);
      var tagAV = "(" + (idx + 1) + ") " + this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).data;
      this.dataEvPeriodo.push(tagAV);
    });

    setTimeout(() => {
      RenderizarEvolucaoPeso(this.dataEvPeso, this.dataEvMassaM, this.dataEvMassaG, this.dataEvPeriodo);
    }, 300);

    this.displayedColumnsKeys = this.displayedColumns2.map(col => col.key);
    this.displayedColumnsKeys3 = this.displayedColumns3.map(col => col.key);
    this.multiDobras = [{ name: 'Subescapular', series: db_Subescapular }, { name: 'Tríceps', series: db_Triceps }, { name: 'Peitoral', series: db_Peitoral }, { name: 'Bíceps', series: db_Biceps }, { name: 'Axila', series: db_AxilarMedia },
    { name: 'Supra Ilíaca', series: db_Suprailiaca }, { name: 'Abdominal', series: db_Adbominal }, { name: 'Coxa', series: db_CoxaMedial }, { name: 'Panturrilha', series: db_Perna }];

    this.multi = [{ name: "Peso", series: av_massaC }, { name: "Magra", series: av_massaM }, { name: "Gordura", series: av_massaG }];
    this.multi2 = av_massaAV;

    this.single = av_massaMp;

    //tabela circ e dobras
    // var arrTcirc = [];
    // this.arrCirc.forEach(item => {
    //   var nomeAv = this.arrAvaliacoes.find(x => x.idavaliacao == item.IdAvaliacao).titulo;
    //   // arrTcirc.push({
    //   //   nome: nomeAv, Ombro: item.MedOmbro, Tronco: item.MedTronco, Abdomem: item.MedAbdomem
    //   //  })

    //    arrTcirc.push({
    //     Avaliação: nomeAv, Ombro: item.MedOmbro, Tórax: item.MedTronco, Abdomem: item.MedAbdomem, Quadril: item.MedQuadril, 'Braço D Rl':  item.MedBracoDRelax,
    //     'Braço D Ct': item.MedBracoDContra, 'Braço E Rl': item.MedBracoERelax, 'Braço E Ct': item.MedBracoEContra, 'Antebraço D': item.MedAntBracoD,
    //      'Antebraço E': item.MedAntBracoE, 'Coxa D': item.MedCoxaD, 'Coxa E': item.MedCoxaE, 'Panturrilha D': item.MedPernaD, 'Panturrilha E': item.MedPernaE
    //    })

    // });



    //this.tabelaDobras = arrTdobras;
    // this.tabelaCircu = arrTcirc;
    // console.log(this.tabelaCircu);
  }

  onSelect(data): void {
    console.log('Item clicked', JSON.parse(JSON.stringify(data)));
  }

  onActivate(data): void {
    console.log('Activate', JSON.parse(JSON.stringify(data)));
  }

  onDeactivate(data): void {
    console.log('Deactivate', JSON.parse(JSON.stringify(data)));
  }



  changeCkAv(idAvali: any, qStatus: any): void {
    console.log(idAvali);
    console.log(qStatus);
    this.arrAvaliacoes.find(x => x.idavaliacao == idAvali).check = qStatus;

  }

  voltar(): void {
    //this._location.back();
    this.router.navigate(['/dashboard/paciente/' + this.idPaciente]);

  }
  // function inlineStyleSVG(_document, nodeIndex) {
  //   const svg = _document.getElementsByClassName('ngx-charts')[nodeIndex].childNodes[0].childNodes[0].firstChild;

  //   const allTextElements = svg.querySelectorAll('text');
  //   for (let i = allTextElements.length - 1; i >= 0; --i) {
  //       allTextElements[i].style.fontFamily = "Roboto,sans-serif";
  //   }
  //   const clonedSVG = this.svgsaver.cloneSVG(svg);
  //   svg.parentNode.replaceChild(clonedSVG, svg);
  // }

  // const options = {
  //   logging: false, scale: 3, onclone: clonedDoc => {
  //       inlineStyleSVG(clonedDoc, 0);
  //   }
  // };

  // html2canvas(document.getElementById('barChart'), options)
  //   .then(canvas => {
  //       const dataURL = canvas.toDataURL("image/png");
  //   });


}

export interface PeriodicElement {
  name: string;
  position: number;
  weight: number;
  symbol: string;
}

const ELEMENT_DATA: PeriodicElement[] = [
  { position: 1, name: 'Hydrogen', weight: 1.0079, symbol: 'H' },
  { position: 2, name: 'Helium', weight: 4.0026, symbol: 'He' },
  { position: 3, name: 'Lithium', weight: 6.941, symbol: 'Li' },
  { position: 4, name: 'Beryllium', weight: 9.0122, symbol: 'Be' },
  { position: 5, name: 'Boron', weight: 10.811, symbol: 'B' },
  { position: 6, name: 'Carbon', weight: 12.0107, symbol: 'C' },
  { position: 7, name: 'Nitrogen', weight: 14.0067, symbol: 'N' },
  { position: 8, name: 'Oxygen', weight: 15.9994, symbol: 'O' },
  { position: 9, name: 'Fluorine', weight: 18.9984, symbol: 'F' },
  { position: 10, name: 'Neon', weight: 20.1797, symbol: 'Ne' },
];